import type { FC, PropsWithChildren } from 'react'

import './styles.scss'

type RowHeight = 'tall' | 'medium' | 'short'

export const Table: FC<PropsWithChildren<{ className?: string; rowHeight?: RowHeight }>> = ({
  children,
  className,
  rowHeight,
}) => {
  const tableClass = `ui-table ${className} ${rowHeight ? `ui-table-${rowHeight}` : ''}`
  return <table className={tableClass}>{children}</table>
}
